import { chainName } from 'utils'

import { genElementValueField } from 'components/Editor/Toolbar/NodeForm/genElementValueField'
import Padding from 'components/Editor/Toolbar/Padding'
import { FieldSegmented, FormField } from 'components/formKit'
import { t } from 'services/Translation'

import type { ReflectionValueFormType } from './reflectionTypes'

const DISPLAY_DOWNLOAD_BUTTON = genElementValueField({
  as: FieldSegmented<boolean>,
  name: 'displayDownloadButton',
  label: t('input.label.displayDownloadButton'),
  defaultValue: true,
})

const ReflectionForm: ReflectionValueFormType = ({ name }) => {
  return (
    <Padding bottom gap sides>
      <FormField config={chainName(name, DISPLAY_DOWNLOAD_BUTTON)} />
    </Padding>
  )
}

export default ReflectionForm
